var React = require('react');

function ExposureControl (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:#fff;}")),React.createElement("path",{"className":"a","d":"M32.578,341.691v30.793H63.371V341.691Zm2.579,28.227L60.805,344.27v25.648Z","transform":"translate(-32.578 -341.691)","key":1}),React.createElement("path",{"d":"M61.3,342.2,33.083,370.411H61.3Z","transform":"translate(-31.787 -340.9)","key":2}),React.createElement("rect",{"className":"a","width":"6.307","height":"1.201","transform":"translate(19.755 21.403)","key":3}),React.createElement("path",{"d":"M41.954,346.828H38.969v-2.985h-1.4v2.985H34.579v1.4h2.985v2.985h1.4v-2.985h2.985Z","transform":"translate(-29.444 -338.321)","key":4})]);
}

ExposureControl.defaultProps = {"width":"30.793","height":"30.793","viewBox":"0 0 30.793 30.793"};

module.exports = ExposureControl;

ExposureControl.default = ExposureControl;
